// src/data.js

// All project images use 1600px x 900px

export const projects = [
    {
      title: "Prophecy",
      subtitle: "React/Python/Flask",
      description:
        "Co-Founder of Prophecy, a platform that makes investing accessible to everyone. We are building a web app to educate and empower all types of users to take control of their investing.",
      image: "./prophecy.png",
      link: "https://www.prophecyfinance.ca/"
    },
    {
      title: "Gleanr",
      subtitle: "React/Next.js/mongoDB",
      description:
        "This was a Morgan Stanley Code to Give winning project! Offers communication between farmers, volunteers, and foodbanks to encourage the process of 'gleaning'.",
      image: "./gleanrlogo.png",
      link: "https://github.com/rajagoat/earth-day-c2g"
    },
    {
      title: "Palette Pioneer",
      subtitle: "React/express.js",
      description:
        "This was a HackED 2024 hackathon project! Acts as a tool for developers and designers to create color palettes randomly or using AI models. Models can generate by text or related hex color!",
      image: "./palette-pioneer.png",
      link: "https://devpost.com/software/palette-pioneer"
    },
    {
      title: "ConnecTech",
      subtitle: "Instagram/Canva",
      description:
        "Upon noticing a gap undergraduate computing science students being aware of events/conferences, I decided to create a platform where I could share opportunities so students can make the most of their degrees.",
      image: "./connectech.png",
      link: "https://www.instagram.com/connectechcanada/",
    },
    {
      title: "QRGo",
      subtitle: "Java",
      description:
        "Android Application created in CMPUT 301. Users navigate their way to QRCodes and scan them to score points and compete with other players.",
      image: "./qrgo.png",
      link: "https://github.com/CMPUT301W22T28/QRGo",
    },
    {
      title: "OlympicOracle",
      subtitle: "Python/React",
      description:
        "A hackathon project that predicts the outcome of the Olympics! Uses machine learning models to predict which country will win a specific medal in a specific sport.",
      image: "./olympicoracle.png",
      link: "https://github.com/n33lp/OlympicOracle-codedex"
    },
    {
      title: "Car-cation",
      subtitle: "Python",
      description:
        "A travel calculation app that determines the estimated cost of your roadtrip based on inputted variables (start/end cities, gas cost, duration, food, hotel).",
      image: "./carcation.png",
      link: "https://mecsimcalc.com/app/6751833/car_cation"
    },
    {
      title: "SitDown",
      subtitle: "Flutter/Firebase",
      description:
        "This was a Hack the North project! A COVID-19 Hybrid Workplace Companion Application. Lets employees book clean tables/spaces to allow for ample cleaning and social distancing.",
      image: "./sitDown.png",
      link: "https://devpost.com/software/sitdown-hbjvmp",
    },
    {
      title: "Social Distribution",
      subtitle: "React/Django/REST APIs/PostGreSQL",
      description:
        "A CMPUT404 project that was essentially a social networking site where users could make accounts and posts allowing other users/servers to view/interact.",
      image: "./socialDist.png",
      link: "https://github.com/kbricker8/cmput404-group-project"
    },
    // {
    //   title: "AlbertaSat",
    //   subtitle: "React/Python",
    //   description:
    //     "Member of the Ground Station Software Team with contributions on a web-based application. Also created, and published blog posts.",
    //   image: "./albertaSat.png",
      
    //   link: "https://albertasat.ca",
    // },
    {
      title: "Coda Connection",
      subtitle: "Coda Document",
      description:
        "This was a Hack the North project! A shareable document with automated email reminders for business and casual events, in and out of the workplace. Acts as a 'virtual water cooler'.",
      image: "./coda.png",
      link: "https://devpost.com/software/connection-ya2mb7"
    },
    // {
    //   title: "Portfolio Website",
    //   subtitle: "HTML/CSS/ReactJS",
    //   description:
    //     "This is the website you're currently on! Used to display additional projects and experience that do not fit on my professional resume.",
    //   image: "./portfolio-clipart.png",
    //   link: "https://github.com/sankalpsaini/Personal-Website",
    // },
  ];

export const volunteering = [
  {
    title: "NeurAlbertaTech",
    subtitle: "Current",
    description:
      "Software Associate for NeurAlbertaTech; working on the development of a web application for the organization",
    image: "./neuralbertatech_cover.webp",
    link: "https://neuralberta.tech/",
  },
  {
    title: "Solar Alberta",
    subtitle: "Current",
    description:
      "General Volunteer for Solar Alberta; assisting with social media posts and member emails",
    image: "./solaralberta.png",
    link: "https://solaralberta.ca/join-us/volunteers/#:~:text=Our%20volunteer%20opportunities%20consist%20of,the%20Solar%20Alberta%20online%20store",
  },
  {
    title: "Ada's Team",
    subtitle: "2022-2024",
    description:
      "Tutor for introductory Computer Science classes for the student group, Ada's Team",
    image: "./adasteam.png",
    link: "https://adasteam.ca/",
  },
  {
      title: "Student's Union",
      subtitle: "2019/2021",
      description:
        "Faculty Leader for the University of Alberta's Students Union. Provided tours for new students and assisted with Week of Welcome events",
      image: "./uasu.png",
      
      link: "https://www.su.ualberta.ca/events/wow/",
    },
  {
    title: "FIRST Robotics",
    subtitle: "Jan 2019",
    description:
      "General Volunteer for FIRST Lego Robotics Competition. Assisted in ushering, set-up, and take-down for youth competition",    
    image: "./firstrobotics.png",
    link: "https://www.firstinspires.org/robotics/fll",
  },
];

export const familiarSkills = [
  {
    name: "Python"
  },
  {
    name: "Java"
  },
  {
    name: "C/C++"
  },
  {
    name: "HTML/CSS"
  },
  {
    name: "Javascript/React.js"
  },
  {
    name: "Linux/Ubuntu"
  },
  {
    name: "REST APIs"
  },
  {
    name: "SQL/SQLite"
  },
  {
    name: "GitHub/GitLab"
  },
  {
    name: "Shell/Bash"
  },
  {
    name: "Next.js/Express.js"
  },
  {
    name: "Jupyter/Julia Notebooks"
  },
];

export const learningSkills = [
  {
    name: "TensorFlow/PyTorch"
  },
  {
    name: "Swift"
  },
  {
    name: "Ansible"
  },
]

export const softSkills = [
  {
    name: "Quick Learner"
  },
  {
    name: "Creativity"
  },
  {
    name: "Flexibility"
  },
  {
    name: "Strong Team Player"
  },
  {
    name: "Communication"
  },
  {
    name: "Time Management"
  },
]

export const photography = [
  {
    title: "British Museum",
    image: "/photography/british-museum-library.jpeg",
    location: "London, UK",
    date: "October 2025",
  },
  {
    title: "Amsterdam Canal",
    image: "/photography/amsterdam-canal.jpeg",
    location: "Amsterdam, NL",
    date: "October 2025",
  },  
  {
    title: "The University of Oxford",
    image: "/photography/oxford.jpeg",
    location: "Oxford, UK",
    date: "October 2025",
  },
  {
    title: "North Vancouver Sunset",
    image: "/photography/north-van-sunset.jpeg",
    location: "North Vancouver, BC",
    date: "February 2025",
  },
  {
    title: "Lake Louise",
    image: "/photography/lake-louise.jpeg",
    location: "Lake Louise, AB",
    date: "Summer 2024",
  },
  {
    title: "Rockies",
    image: "/photography/icefields-parkway.jpeg",
    location: "Icefields Parkway, AB",
    date: "Summer 2024",
  },
  {
    title: "Varadero Beach",
    image: "/photography/varadero-beach.jpeg",
    location: "Varadero, Cuba",
    date: "May 2024",
  },
  {
    title: "Winter in the River Valley",
    image: "/photography/edmonton-bridge.jpeg",
    location: "Edmonton, AB",
    date: "March 2019",
  },
]